import React, { useState, useRef, useEffect } from 'react';
import { Box, Button, Typography } from '../utils/mui-imports';

function Caption({ caption, align, numberOfLines = 1 }) {
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const typographyRef = useRef(null);
  const [textWidth, setTextWidth] = useState('85%');

  useEffect(() => {
    if (typographyRef.current) {
      const element = typographyRef.current;
      if (numberOfLines === 1) {
        // Check horizontal overflow when showing only one line
        setIsTruncated(element.scrollWidth > element.clientWidth);
      } else {
        // Check vertical overflow when showing multiple lines
        setIsTruncated(element.scrollHeight > element.clientHeight);
      }
    }
  }, [caption, numberOfLines]);

  return (
    <Box
      sx={{
        overflowY: isExpanded ? 'scroll' : 'hidden',
        position: 'relative',
        alignItems: 'center'
      }}
    >
      <Typography
        align={align ? align : 'left'}
        ref={typographyRef}
        fontSize="0.75rem"
        sx={{
          width: textWidth,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          // When not expanded, use truncation styles
          ...(!isExpanded && numberOfLines > 1 && {
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: numberOfLines,
          }),
          ...(!isExpanded && numberOfLines === 1 && {
            whiteSpace: 'nowrap',
          }),
          // When expanded, show full text with normal wrapping
          ...(isExpanded && {
            whiteSpace: 'normal',
            display: 'block'
          }),
        }}
        className="fade-in"
      >
        {caption}
      </Typography>
      {!isExpanded && isTruncated && (
        <Button
          variant="plain"
          sx={{
            p: 0,
            position: 'absolute',
            right: 0,
            bottom: -1.25,
            cursor: 'pointer',
            fontSize: '0.75rem',
            color: 'black',
            fontWeight: 'bold',
            textTransform: 'lowercase'
          }}
          onClick={() => {
            setTextWidth('100%');
            setIsExpanded(true);
          }}
        >
          more
        </Button>
      )}
    </Box>
  );
}

export default Caption;
